import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthSessionInterceptorService {

  /**
   * コンストラクタ。
   * @memberof AuthSessionInterceptorService
   */
  constructor() { }

  /** 500エラー通知イベント用 */
  private errorSubject = new Subject<void>();
  /** エラー通知受け取り用 */
  public error$ = this.errorSubject.asObservable();

  /**
   * 500エラー発生通知メソッド
   * @memberof AuthSessionInterceptorService
   */
  public notifySystemError(): void {
    this.errorSubject.next();
  }
}
